import React from 'react';
import {NavLink} from "react-router-dom";
import FadeSlideIn from "../../common/FadeSlideIn";
import socialsYoutube from "../../../resources/socialsYoutube.png";
import socialsTwitch from "../../../resources/socialsTwitch.png";
import socialsDiscord from "../../../resources/socialsDiscord.png";
import socialsCommunity from "../../../resources/landingSocialsCommunity.png";

const LandingSocials = () => {
    return (<FadeSlideIn>
        <div className="landingSocials">
            <div className="container">

                <div className="landingSocialsOuter">

                    <p>JOIN KAZLIC</p>
                    <img src={socialsCommunity} alt=""/>

                    <div className="landingSocialsWrapper">

                        <div className="landingSocial">
                            <img src={socialsYoutube} alt=""/>
                            <p>Watch Videos Everyday</p>
                            <NavLink to="https://www.youtube.com/@Kazlicc" target={"_blank"} className="btn btn-youtube">WATCH NOW</NavLink>
                        </div>

                        <div className="landingSocial">
                            <img src={socialsTwitch} alt=""/>
                            <p>Watch new reels daily!</p>
                            <NavLink to="https://www.instagram.com/kazthedegen/" target={"_blank"} className="btn btn-twitch">JOIN NOW</NavLink>
                        </div>

                        <div className="landingSocial">
                            <img src={socialsDiscord} alt=""/>
                            <p>Join the community</p>
                            <NavLink to="https://discord.gg/kazlic" target={"_blank"} className="btn btn-discord">WATCH NOW</NavLink>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </FadeSlideIn>);
}
export default LandingSocials;